module.exports = __webpack_public_path__ + "img/admins.a86bf3af.svg";